import $ from 'jquery';
import { Url } from 'rustig';

$(function () {
  $(document).on('click.rustig.tabs', '[data-tab]', function () {
    let tabId = $(this).data('tab');

    let setQueryParameter = function ($element: JQuery) {
      if ($element.length && $element.data('url')) {
        let url = new Url($element.data('url'))
          .setQueryParameter('selectedTab', tabId)
          .toUrl();
        $element.data('url', url);
      }
    };

    setQueryParameter($('[data-prior-eval]'));
    setQueryParameter($('[data-next-eval]'));
  });
});